export async function getContent() {
    const sessionData = sessionStorage.getItem('PK_Data');
  
    if (sessionData) {
      // If data already exists, parse and return it
      return JSON.parse(sessionData);
    } else {
      // Otherwise, fetch it
      const response = await fetch('https://apiv2.mobileartsme.com/getpikabooContent');
      const data = await response.json();
      sessionStorage.setItem('PK_Data', JSON.stringify(data));
      return data;
    }
  }
  


  

// videoFunctions.js or wherever you define it
export async function addToFav(video, showAlert) {
  const user = localStorage.getItem('PK_user');

  if (!user) {
    const modal = new window.bootstrap.Modal(document.getElementById('loginModal'));
    modal.show();
    return;
  }

  const favorites = localStorage.getItem('PK_Favorites');
  let favs = favorites ? JSON.parse(favorites) : [];

  const index = favs.findIndex((item) => item.id === video.id);

  if (index !== -1) {
    // Remove from favorites
    favs.splice(index, 1);
    localStorage.setItem('PK_Favorites', JSON.stringify(favs));
    showAlert?.('Removed from Favorites', 'warning');
  } else {
    // Add to favorites
    favs.push(video);
    localStorage.setItem('PK_Favorites', JSON.stringify(favs));
    showAlert?.('Added to Favorites', 'success');
  }
}

  